export const validate_password = `query validate_password($old_password: String!){
    validate_password(old_password: $old_password)
}`;
